<template>
  <div class="c-outages-search">
    <form
      class="c-outages-search__form"
      :class="{
        'c-outages-search__form--list-view': outagePageView === 'list',
      }"
    >
      <label class="c-outages-search__label">SEARCH</label>
      <div class="c-outages-search__input-wrapper">

      <input
        class="c-outages-search__input"
        type="text"
        placeholder="Enter street name"
        v-model="searchText"
        @input="clearMarkerFilter"
      />
      <div class="c-outages-search__information" v-if="searchText != '' || filterMarkerSelectedLocation != null">
        <span class="c-outages-search__results"
          >{{ getAllFilteredOutages.length }} of
          {{ getAllOutagesByTimeFilter.length }} results showing</span
        >
        <span @click="clearAllFilters" class="c-outages-search__clear"
          >CLEAR</span
        >
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields([
      "searchText",
      "outagePageView",
      "filterMarkerSelectedLocation",
    ]),
    ...mapGetters(["getAllFilteredOutages", "getAllOutagesByTimeFilter"]),
  },
  methods: {
    clearAllFilters() {
      this.$store.commit("clearAllFilters");
      this.$store.commit("resetMapView");
    },
    clearMarkerFilter() {
      this.$store.commit("clearMarkerFilter");
    },
  },
};
</script>

<style lang="scss"></style>
